import React, { useState, useEffect } from 'react';
import CRUDList from '../Common/CRUDList';
import { airports, countries, timezones } from '../../services/api';

const airportStatuses = { 0: 'Closed', 1: 'Open' };
const airportStatusColors = { 0: 'badge-danger', 1: 'badge-success' };

function AirportForm({ formData, setFormData }) {
  const [countriesList, setCountriesList] = useState([]);
  const [timezonesList, setTimezonesList] = useState([]);

  useEffect(() => {
    loadCountries();
    loadTimezones();
  }, []);

  const loadCountries = async () => {
    try {
      const response = await countries.getAll();
      setCountriesList(response.data);
    } catch (err) {
      console.error('Failed to load countries', err);
    }
  };

  const loadTimezones = async () => {
    try {
      const response = await timezones.getAll();
      setTimezonesList(response.data);
    } catch (err) {
      console.error('Failed to load timezones', err);
    }
  };

  return (
    <>
      <div className="form-group">
        <label>IATA Code *</label>
        <input
          type="text"
          value={formData.airport_iata_code || ''}
          onChange={(e) => setFormData({ ...formData, airport_iata_code: e.target.value.toUpperCase() })}
          maxLength={3}
          required
        />
      </div>

      <div className="form-group">
        <label>ICAO Code *</label>
        <input
          type="text"
          value={formData.airport_icao_code || ''}
          onChange={(e) => setFormData({ ...formData, airport_icao_code: e.target.value.toUpperCase() })}
          maxLength={4}
          required
        />
      </div>

      <div className="form-group">
        <label>Country *</label>
        <select
          value={formData.airport_country_id || ''}
          onChange={(e) => setFormData({ ...formData, airport_country_id: parseInt(e.target.value) })}
          required
        >
          <option value="">Select country</option>
          {countriesList.map(country => (
            <option key={country.country_id} value={country.country_id}>
              {country.country_name} ({country.country_iso_code_2})
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Timezone *</label>
        <select
          value={formData.airport_tz_id || ''}
          onChange={(e) => setFormData({ ...formData, airport_tz_id: parseInt(e.target.value) })}
          required
        >
          <option value="">Select timezone</option>
          {timezonesList.map(tz => (
            <option key={tz.tz_id} value={tz.tz_id}>
              {tz.tz_code}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Status *</label>
        <select
          value={formData.airport_status ?? 1}
          onChange={(e) => setFormData({ ...formData, airport_status: parseInt(e.target.value) })}
          required
        >
          <option value="1">Open</option>
          <option value="0">Closed</option>
        </select>
      </div>

      <div className="form-group">
        <label>Latitude</label>
        <input
          type="number"
          step="0.000001"
          value={formData.airport_latitude || ''}
          onChange={(e) => setFormData({ ...formData, airport_latitude: e.target.value ? parseFloat(e.target.value) : null })}
          placeholder="-90.000000 to 90.000000"
          min={-90}
          max={90}
        />
      </div>

      <div className="form-group">
        <label>Longitude</label>
        <input
          type="number"
          step="0.000001"
          value={formData.airport_longitude || ''}
          onChange={(e) => setFormData({ ...formData, airport_longitude: e.target.value ? parseFloat(e.target.value) : null })}
          placeholder="-180.000000 to 180.000000"
          min={-180}
          max={180}
        />
      </div>
    </>
  );
}

function AirportsList() {
  return (
    <CRUDList
      title="Airports"
      api={airports}
      columns={['ID', 'IATA Code', 'ICAO Code', 'Country', 'Timezone', 'Status', 'Coordinates']}
      FormComponent={AirportForm}
      defaultFormData={{
        airport_iata_code: '',
        airport_icao_code: '',
        airport_country_id: '',
        airport_tz_id: '',
        airport_status: 1,
        airport_latitude: null,
        airport_longitude: null
      }}
      useOldStyle={true}
      renderRow={(item) => (
        <>
          <td>{item.airport_id}</td>
          <td><span className="badge badge-info">{item.airport_iata_code}</span></td>
          <td><span className="badge badge-info">{item.airport_icao_code}</span></td>
          <td>{item.country_name || '-'}</td>
          <td style={{ fontSize: '0.9em' }}>{item.tz_code || '-'}</td>
          <td>
            <span className={`badge ${airportStatusColors[item.airport_status]}`}>
              {airportStatuses[item.airport_status]}
            </span>
          </td>
          <td>
            {item.airport_latitude != null && item.airport_longitude != null
              ? `${item.airport_latitude}, ${item.airport_longitude}`
              : '-'}
          </td>
        </>
      )}
    />
  );
}

export default AirportsList;
